export const GLOBALS_SELECTED_SEDE_SET = 'GLOBALS_SELECTED_SEDE_SET';